import { GetTrialsMenuItems } from "@/api/dtos";
import MenuItemContext from "@/contexts/Tiles/MenuItemContext";
import useMenuItems from "@/hooks/tiles/useMenuItems";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router";



export interface IMenuItemsProps {
    initial?: GetTrialsMenuItems;
    trialId: number
}

export const MenuItemsProvider: FC<PropsWithChildren<IMenuItemsProps>> = ({ initial, children, trialId }) => {
    const institutionId = useParams()?.institutionId;

    const menuItems = useMenuItems(trialId, institutionId, {fallbackData: initial});

    return (
        <MenuItemContext.Provider value={menuItems}>
            {children}
        </MenuItemContext.Provider>
    );
}

export default MenuItemsProvider;
